import axios from "axios";
import { default as Config } from "./../config/config";
import { API_URL, REQUEST_RESPONSE_ENCRYPTION, SKIP_ENCRYPTION_ROUTE_KEYWORDS } from "./../config/constant";
import secureStorage from "./../config/encrypt";
import { toast } from "react-toastify";
import store from '../store/store';
import { notificationUpdate } from "../store/allAction";
import CryptoJS from "crypto-js";
import forge from 'node-forge';

/**
 * Decrypts an encrypted API response.
 */
const decryptResponse = (encryptedResponse) => {
	try {
		const { encrypted_data, encrypted_symmetric_key, iv } = encryptedResponse;

		const responseAesKey = CryptoJS.enc.Utf8.parse(REQUEST_RESPONSE_ENCRYPTION.response_aes_key);

		const zeroIv = CryptoJS.lib.WordArray.create(new Array(4).fill(0));

		const decryptedSymmetricKeyBase64 = CryptoJS.AES.decrypt(
			encrypted_symmetric_key,
			responseAesKey,
			{
				iv: zeroIv,
				mode: CryptoJS.mode.CBC,
				padding: CryptoJS.pad.Pkcs7
			}
		).toString(CryptoJS.enc.Utf8);

		const symmetricKey = CryptoJS.enc.Base64.parse(decryptedSymmetricKeyBase64);

		const ivWordArray = CryptoJS.enc.Base64.parse(iv);

		const decryptedData = CryptoJS.AES.decrypt(
			encrypted_data,
			symmetricKey,
			{
				iv: ivWordArray,
				mode: CryptoJS.mode.CBC,
				padding: CryptoJS.pad.Pkcs7
			}
		).toString(CryptoJS.enc.Utf8);

		return JSON.parse(decryptedData);

	} catch (error) {
		console.error('Decryption failed:', error);
		throw new Error('Failed to decrypt response');
	}
};

/**
 * Encrypts request payload for API call.
 */
const encryptPayload = (data) => {
	try {
		const symmetricKey = CryptoJS.lib.WordArray.random(32);
		const iv = CryptoJS.lib.WordArray.random(16);

		const encryptedData = CryptoJS.AES.encrypt(
			JSON.stringify(data),
			symmetricKey,
			{
				iv: iv,
				mode: CryptoJS.mode.CBC,
				padding: CryptoJS.pad.Pkcs7
			}
		).toString();

		const publicKey = forge.pki.publicKeyFromPem(REQUEST_RESPONSE_ENCRYPTION.publicKey);
		const symmetricKeyBytes = forge.util.hexToBytes(symmetricKey.toString(CryptoJS.enc.Hex));
		const encryptedSymmetricKey = forge.util.encode64(
			publicKey.encrypt(symmetricKeyBytes, 'RSA-OAEP')
		);

		return {
			encrypted_data: encryptedData,
			encrypted_symmetric_key: encryptedSymmetricKey,
			iv: iv.toString(CryptoJS.enc.Base64)
		};
	} catch (error) {
		console.error("Encryption failed: ", error);
		throw new Error("Failed to encrypt response");
	}
};

axios.interceptors.response.use(
	(response) => {
		if (response.headers["is_encrypt_response"] && +response.headers["is_encrypt_response"] === 1) {
			response.data = decryptResponse(response.data);
		}
		if (response.data && response.data.data && !response.data.data.isNotification) {
			let userId = (secureStorage.getItem("authUserInfo") && secureStorage.getItem("authUserInfo")['user_data']) ? secureStorage.getItem("authUserInfo")['user_data']['user_id'] : 0;
			if (userId > 0) {
				store.dispatch(notificationUpdate(userId));
			}
		}
		if (response.data && response.data.status !== 200) {
			// console.error(`${response.data.status} - ${response.data.message}`, response.data)
			// if(response.data.status == 400)
			//     window.commonErrorToast(response.data.message)
			//     toast.error(`${response.data.status} - ${response.data.message}`);
		}
		return response;
	},
	(error) => {
		// handle error
		if (error.response) {
			if (+error?.response?.headers?.['is_encrypt_response'] === 1 && error?.response?.data) {
				error.response.data = decryptResponse(error.response.data);
			}
			if (error.response.status === 503) {
				// toast.error(`${error.response.status} - ${error.response.statusText}`);
			} else if (error.response.status === 401) {
				secureStorage.removeItem("authUserInfo")
				if (error.response.data.errors === "TokenEmptyInCache")
					toast.error(
						`${error.response.data.status} - ${error.response.data.message}`
					);

				//window.location.href = '/refresh-token?redirectUrl='+window.location.pathname;
				window.location.href = "/login";
				console.log(error)
			} else if (
				error.response.data.status === 400 &&
				(error.response.data.message === "invalid_refresh_token" ||
					error.response.data.message === "access_token_expired")
			) {
				// if(error.response.data.errors == "TokenEmptyInCache")
				//toast.error(`${error.response.data.status} - ${error.response.data.message}`);
				// window.location.href = '/logout';
			} else if (error.response.data.status === 400) {
				toast.error(error.response.data.message);
			}
		}

		return error.response;
	}
);

/**
 * Encrypts request payload before sending.
 * Skips encryption for whitelisted routes and FormData.
 */
axios.interceptors.request.use((config) => {
	if (!(config.url && SKIP_ENCRYPTION_ROUTE_KEYWORDS.some(keyword => config.url.includes(keyword))) && !(config.data instanceof FormData)) {
		config.headers.set("is_encrypt_response", 1);

		if (config.data && Object.keys(config.data).length) {
			config.data = encryptPayload(config.data);
		}
	}

	return config;
}, (error) => {
	return Promise.reject(error);
});

window.commonErrorToast = function (error) {
	if (typeof error === "string") toast.error(error);
	else if (error.message) toast.error(error.message);
};

const ServiceMethod = {
	getToken() {
		// let fetchHeader = (secureStorage.getItem('loginUserInfo'))
		//     ? secureStorage.getItem('loginUserInfo')
		//     : {};
		// return (fetchHeader && fetchHeader.data && fetchHeader.data.token)
		//     ? fetchHeader.data.token : null;
		return secureStorage.getItem("authUserInfo") &&
			secureStorage.getItem("authUserInfo")["token"]
			? secureStorage.getItem("authUserInfo")["token"]
			: "";
	},
	delete(URL, body, headers) {
		headers = headers || {};
		headers["Authorization"] = this.getToken();
		headers["Accept-Language"] = secureStorage.getItem("lang");
		headers["source"] = "web";
		URL = URL[0] === "/" ? URL.substr(1) : URL;
		return axios.delete(`${API_URL.COMMON_GATEWAY_API}${URL}`, body, {
			headers,
		});
	},
	post(URL, body, headers) {
		headers = headers || {};
		headers["Authorization"] = this.getToken();
		headers["Accept-Language"] = secureStorage.getItem("lang");
		headers["source"] = "web";
		headers["tenant"] = secureStorage.getItem("entitySource");
		URL = URL[0] === "/" ? URL.substr(1) : URL;
		headers['vertical_id'] = body?.vertical_type === 'hrf' ? 2 : 1
		return axios.post(`${API_URL.COMMON_GATEWAY_API}${URL}`, body, {
			headers,
		});
	},
	put(URL, body, headers) {
		headers = headers || {};
		headers["Authorization"] = this.getToken();
		headers["Accept-Language"] = secureStorage.getItem("lang");
		headers["source"] = "web";
		headers["tenant"] = secureStorage.getItem("entitySource");
		headers['vertical_id'] = body?.vertical_type === 'hrf' ? 2 : 1
		URL = URL[0] === "/" ? URL.substr(1) : URL;
		return axios.put(`${API_URL.COMMON_GATEWAY_API}${URL}`, body, {
			headers,
		});
	},
	get(URL, query, headers) {
		headers = headers || {};
		headers["Authorization"] = this.getToken();
		headers["Accept-Language"] = secureStorage.getItem("lang");
		headers["source"] = "web";
		headers["tenant"] = secureStorage.getItem("entitySource");
		headers['vertical_id'] = query?.vertical_type === 'hrf' ? 2 : 1
		URL = URL[0] === "/" ? URL.substr(1) : URL;
		return axios.get(`${API_URL.COMMON_GATEWAY_API}${URL}`, {
			params: query,
			headers,
		});
	},
	patch(URL, body, headers) {
		headers = headers || {};
		headers["Authorization"] = this.getToken();
		headers["Accept-Language"] = secureStorage.getItem("lang");
		URL = URL[0] === "/" ? URL.substr(1) : URL;
		return axios.patch(`${API_URL.COMMON_GATEWAY_API}${URL}`, body, {
			headers,
		});
	},
	uploadFilesToS3(postdata, headers) {
		headers = headers || {};
		headers["tenant"] = secureStorage.getItem("entitySource");
		let URL = API_URL.COMMON_GATEWAY_API.replace('pb/', 'core/')
		// let URL = "https://int-gcloud-stage.oto.com/core/"
		return axios.post(
			`${URL}commonservice/docs_upload`,
			postdata,
			{ headers }
		);
	},
};

export default ServiceMethod;
